export default "__VITE_ASSET__BM5afErV__"